<template>
    <div>
        <div v-if="!attributes.length" class="has-text-centered">
            <h2 class="is-size-4 ">No hay atributos para el producto...</h2>
        </div>
        <AttrFormEl 
        v-for="(x, index) in attributes" 
        :key="x.id" 
        :index="index" 
        :data="x"
        :attributesDetail="attributesDetail"
        :attrValDetail="attrValDetail"
        :attrValCreate="attrValCreate"
        @reloadAttrs="emitReloadAttrs"/>
       
        <div class="columns is-centered m-t-30">
            <div class="column is-full has-text-centered">
                <b-button 
                type=is-primary 
                rounded
                @click="isAddModalActive=true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Agregar atributos
                </b-button>
            </div>
        </div>

         <b-modal :active.sync="isAddModalActive"  scroll="keep">
            <div class="modal-card has-text-centered" style="width: auto">

                <div class="modal-card-body">
                    <p class="modal-card-title m-b-10 has-text-centered">Agregar atributos</p>
                    <AttrAddForm 
                    v-for="(x, i) in newAttrList" 
                    :data="x" 
                    :key="x.id" 
                    :index="i" 
                    @deleteAttribute="deleteNewAttribute(i)"/>
                    <div class="columns is-centered">
                        <div class="column is-full has-text-centered">
                            <b-button 
                            type="is-text"
                            rounded
                            @click="addItemNewAttrList">
                                <b-icon
                                icon="plus"
                                size="is-small">
                                </b-icon>
                                Nueva fila
                            </b-button>
                        </div>
                    </div>
                    <div class="columns is-centered">
                        <div class="column is-full has-text-centered">
                            <b-button type="is-outlined is-centered has-text-centered"
                            @click="isAddModalActive=false">
                                Cancelar
                            </b-button>
                            <b-button 
                            type="is-primary is-centered has-text-centered"
                            @click="saveAttrs">
                                <b-icon
                                icon="save"
                                size="is-small">
                                </b-icon>
                                Guardar atributos
                            </b-button>
                        </div>
                    </div>
                </div>
            
                
            
            </div>
        </b-modal>

    </div>
</template>

<script>
import AttrFormEl from "./AttrFormEl.vue"
import AttrAddForm from "./AttrAddForm.vue"
import {getHandler, postHandler} from "./../../../../services/http.js"

export default {
    components:{
        AttrFormEl,
        AttrAddForm
    },
    props:{
        attributesList:{
            type:String,
            default:"",
        },
        attributesDetail:{
            type:String,
            default:""
        },
        attrValDetail:{
            type:String,
            default:""
        },
        attrandvalCreate:{
            type:String,
            default:""
        },
        attrValCreate:{
            type:String,
            default:""
        },
        attributes:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
            loading:false,
            
            isAddModalActive:false,
            newAttrList:[
                {
                    title:"",
                    values:[]
                }
            ]
        }
    },
    methods:{
        emitReloadAttrs(){
            this.$emit("reFetchAttrs")
        },
        deleteNewAttribute(index){
            this.newAttrList.splice(index, 1)
        },
        addItemNewAttrList(){
           this.newAttrList.push(
               {
                   title:"",
                   values:[]
               }
           )
        },
        async saveAttrs(){
            this.loading = true
            let success = {
                resource:'notify'
            }
            let error = {
                resource:'notify'
            }
            let response = await postHandler(this.attrandvalCreate, this.newAttrList, {success, error})
            this.loading = false
            this.isAddModalActive = false
            this.newAttrList = []
            this.$emit("reFetchAttrs")
        }
    },
    
}
</script>
